The identifier for the reason why the position failed to post or update.
